import { Injectable } from "@angular/core"
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router"
import { Router } from "@angular/router"
import { UserService } from "../services/user.service"

@Injectable()
export class TeacherAuthGuard implements CanActivate {
    constructor(private userService: UserService, private router: Router) {}

    public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.userService.hasStudentExperience()) {
            this.router.navigate(["/student"])
            return false
        }

        if (!this.userService.isLoggedIn()) {
            this.router.navigate(["/"])
            return false
        }
        return true
    }
}
